import Reveal from "@/components/home/Reveal";
import { useRegisterModal } from "@/components/home/RegisterModalProvider";
import { Link } from "react-router-dom";
import { Camera, MessageCircle, MapPin, ArrowRight } from "lucide-react";

const STEPS = [
  { icon: Camera, title: "Sube una foto de tu menú", text: "La IA la convierte en menú digital con tus platillos, precios y fotos. Sin capturar nada a mano.", img: "/images/paso2-productos.jpg", alt: "Menú digital generado por IA" },
  { icon: MessageCircle, title: "Conecta tu WhatsApp de negocio", text: "Los pedidos llegan directo a tu chat. Tu cliente solo escribe \"Hola\" y ordena, sin descargar apps.", img: "/images/paso4-whatsapp-ordering.png", alt: "Pedido llegando por WhatsApp" },
  { icon: MapPin, title: "Actívate en Google Maps", text: "Tu menú se sincroniza con tu ficha de Google. Tus clientes te encuentran y ordenan desde ahí.", img: "/images/paso3-google-business.png", alt: "Menú en Google Business Profile" },
];

export const HowItWorks = () => {
  const { openModal } = useRegisterModal();
  return (
    <section id="como-funciona" className="mt-section bg-white" data-testid="how-it-works-section">
      <div className="mt-container">
        <Reveal className="max-w-2xl">
          <p className="text-brand-orange font-semibold text-sm uppercase tracking-wider">Cómo funciona</p>
          <h2 className="mt-2 text-3xl sm:text-4xl lg:text-5xl leading-tight">En 3 pasos ya estás vendiendo.</h2>
        </Reveal>
        <div className="mt-12 grid md:grid-cols-3 gap-6 lg:gap-8">
          {STEPS.map(({ icon: Icon, title, text, img, alt }, i) => (
            <Reveal key={title} delay={i * 110} className="relative rounded-3xl border border-orange-100 bg-brand-cream/50 overflow-hidden flex flex-col" data-testid={`step-card-${i + 1}`}>
              <div className="p-7 flex-1">
                <div className="flex items-center gap-4">
                  <span className="font-heading font-extrabold text-5xl text-brand-orange/20 leading-none">{i + 1}</span>
                  <div className="w-12 h-12 rounded-xl bg-brand-orange text-white grid place-items-center"><Icon className="w-6 h-6" /></div>
                </div>
                <h3 className="mt-5 text-xl leading-snug">{title}</h3>
                <p className="mt-2 text-gray-600 leading-relaxed">{text}</p>
              </div>
              <div className="px-7 pb-0"><img src={img} alt={alt} loading="lazy" className="w-full h-44 object-cover object-top rounded-t-2xl border border-b-0 border-orange-100 shadow-[0_-8px_30px_rgba(255,102,18,0.12)]" /></div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={200} className="mt-12 flex flex-col sm:flex-row items-center gap-4">
          <button onClick={() => openModal({ source: "plan" })} className="btn-mt btn-mt-primary btn-mt-lg" data-track="como-funciona-empezar" data-testid="how-it-works-cta">Empezar ahora <ArrowRight className="w-5 h-5" /></button>
          <Link to="/guia" className="text-brand-orange-dark font-semibold hover:underline inline-flex items-center gap-1" data-track="como-funciona-guia" data-testid="how-it-works-guide-link">
            Ver la guía visual paso a paso <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default HowItWorks;
